import React from 'react';
import { colors } from '../../styles/styles';

/**
 * Reusable icon button component
 * Provides consistent styling for icon-only buttons across the app
 */
const IconButton = ({
  onClick,
  icon,
  ariaLabel,
  size = 32,
  style = {},
  background = 'none',
  padding = 4,
  indicatorColor = null,
  indicatorVisible = false
}) => {
  return (
    <button
      onClick={onClick}
      aria-label={ariaLabel}
      style={{
        background,
        border: 'none',
        borderRadius: '4px',
        padding: `${padding}px`,
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: `${size}px`,
        height: `${size}px`,
        position: 'relative',
        ...style
      }}
    >
      {icon}
      
      {/* Indicator dot (optional) */}
      {indicatorVisible && (
        <span style={{
          position: 'absolute',
          top: '-2px',
          right: '-2px',
          width: '8px',
          height: '8px',
          borderRadius: '50%',
          backgroundColor: indicatorColor || colors.accent.white,
        }}></span>
      )}
    </button>
  );
};

export default IconButton; 